export function removeItemByName(arr, targetName) {
  for (let i = 0; i < arr.length; i++) {
    if (arr[i].name === targetName) {
      arr.splice(i, 1) // Remove the current object if it has the target ID
      return
    }

    if (arr[i].children && arr[i].children.length > 0) {
      removeItemByName(arr[i].children, targetName) // Recursively check children
      if (arr[i].children.length === 0) {
        delete arr[i].children // Remove the "children" property if it becomes empty
      }
    }
  }
}
